
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6tEA6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $6mKj3 = parcelRequire("6mKj3");


var $81LQM = parcelRequire("81LQM");

/* CopyWithRovoBannerCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $3jwuS = parcelRequire("3jwuS");

/* KeepPageStructureButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $ccHMk = parcelRequire("ccHMk");





var $3AUgb = parcelRequire("3AUgb");


var $7yDmn = parcelRequire("7yDmn");


var $3sFtD = parcelRequire("3sFtD");


var $jO3S6 = parcelRequire("jO3S6");


var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");





var $9XexZ = parcelRequire("9XexZ");


var $6VfGD = parcelRequire("6VfGD");

const $9bd064651c03f40a$var$KEEP_PAGE_STRUCTURE_PROMPT = `Update the document using the ConfluenceCreationTool. ` + `Convert it into a reusable template while strictly preserving page structure and macros ` + `but aggressively clearing user-specific content. ` + // ADF preamble
`ADF CONTEXT: This document uses Atlassian Document Format (ADF). ` + `Macros are represented as extension nodes: bodiedExtension (macros with a body/content area), ` + `extension (macros with no body), and inlineExtension (inline macros). ` + `Preserve all extension nodes and their attrs entirely \u{2014} these are the macro's identity and configuration. ` + `Only clear content inside a bodiedExtension's body when it is obviously user-generated content. ` + `For placeholder text color, use a textColor mark with color "#97a0af" (neutral gray). ` + `In ADF, newlines are represented as hardBreak nodes and blank lines are empty paragraph nodes \u{2014} ` + `remove both when clearing content. ` + `Follow these rules exactly: ` + // 1. Page structure and headings
`PAGE STRUCTURE AND HEADINGS: ` + `Do not change the page title text or any heading text (H1\u{2013}H6). ` + `Do not add, remove, rename, or reorder any headings. ` + `Preserve the nesting and order of all structural blocks exactly as they are ` + `(headings, tables, panels, expands, layouts, code blocks, decision lists, action item lists, etc.). ` + `Non-structural blocks like user-content paragraphs, bullet lists, and ordered lists within a section will be replaced per the placeholder rules below. ` + `Do not flatten multi-column layouts or merge sections. Keep all layout sections and columns as they are. ` + // 2. Macros and special elements
`MACROS AND SPECIAL ELEMENTS: ` + `Preserve all native Confluence macros in their current positions and configurations. ` + `Do not delete, add, reorder, or change the type of any macro. ` + `This includes: panels (info, note, warning, error, success), expand/collapse sections, ` + `decision lists, action items, status lozenges, dates, mentions, dividers, table of contents, and code blocks. ` + `Preserve all 3rd-party or unknown macros as structural containers: do NOT remove or change the macro itself. ` + `Do not alter macro parameters or configuration fields (such as settings, options, or structural flags), ` + `except where content must be cleared as described below. ` + // 3. What content to remove or replace
`CONTENT TO REMOVE OR REPLACE: ` + `Treat the document's user-specific content as unsafe and aggressively clear it, while keeping the structural "shell" intact. ` + `Remove or clear all of the following wherever they appear in the content body: ` + `inline statuses (status lozenges), inline dates, inline mentions, inline smart links, ` + `and embedded content (iframes, embedded pages, embedded Jira issues, embed macros, and any embedCard or inlineCard nodes) ` + `(and any inline text that consists solely of those elements). ` + `Remove all link marks from any text that remains as a preserved element \u{2014} ` + `if text is kept because it is part of a structural element (e.g., heading text, table header, panel title, label column), ` + `strip the link mark so the text is plain and unlinked. No hyperlinks should remain in the output. ` + `Text inside body paragraphs and list items that represent specific user-entered content. ` + `When clearing content from sections or table cells, remove all hardBreak nodes and empty paragraph nodes from the original content. ` + `Collapse all cleared content into a single clean block \u{2014} do not leave behind blank lines, empty nodes, or whitespace artifacts. ` + `After clearing, replace content with structured placeholders as described in the placeholder rules below, ` + `so the overall structure and reading order of sections remains intact. ` + // 4. Placeholder strategy by heading section
`PLACEHOLDER STRATEGY BY HEADING SECTION: ` + `Work at the level of each heading "section": a section is a heading and all normal body content ` + `(paragraphs and lists, plus any surrounding panels/expands/layouts) that belong to that heading, ` + `up until the next heading of the same or higher level. ` + `For each section that currently contains any user body text, inline statuses/dates/mentions/smart links, or images/diagrams: ` + `remove ALL original user content from that section: all paragraph nodes, list nodes, inline nodes (statuses, dates, mentions, smart links), ` + `hardBreak nodes, empty paragraph nodes, and any now-empty text nodes. ` + `After removal, the section should contain ONLY structural containers (panels, expands, layouts, tables) and one single placeholder. ` + `Insert exactly ONE concise placeholder paragraph for the entire section that describes what the user should write there. ` + `The placeholder should be bracketed: [Describe X...]. ` + `Be specific and instructive based on the heading text and nearby structure. ` + `Example under "Project Risks": [Summarize the main project risks, their likelihood, impact, and planned mitigations.] ` + `CRITICAL: Each heading section gets exactly ONE placeholder paragraph total \u{2014} never more. ` + `Do NOT create additional paragraphs, list items, or duplicate placeholders inside panels, expands, or layout columns within the same section. ` + `Place the single placeholder at the top of the section content, before any structural containers. ` + `For sections that are already completely empty (no body text, no lists, no images, and no user content) before you start, ` + `leave them exactly as they are. Do not add placeholders into genuinely empty sections. ` + // 5. Placeholder styling
`PLACEHOLDER STYLING: ` + `Apply italic formatting to all placeholder text so it is visually distinct from real content. ` + `If a neutral gray text color is supported without custom styling issues, apply a gray text color to placeholders as well. ` + `If you are not sure the color will be applied correctly, use italic only and skip the color. ` + `Do not modify the styling of surrounding structural elements (headings, panels, layouts, etc.) beyond inserting the placeholder text. ` + // 6. Inline statuses, dates, mentions, and smart links
`INLINE STATUSES, DATES, MENTIONS, AND SMART LINKS: ` + `Explicitly remove all of the following from the user content: ` + `inline status lozenges, inline date macros, inline user or team mentions, ` + `inline smart links or link cards that refer to specific pages, issues, docs, or external URLs. ` + `Do not leave these elements or their original display text in the transformed template. ` + `If a paragraph or list item consists solely of these elements (with no other text), remove that paragraph or list item entirely. ` + `The structural placeholder at the section level is sufficient to guide users; ` + `you do NOT need to add one placeholder per removed inline element. ` + // 7. Images, screenshots, diagrams, and media
`IMAGES, SCREENSHOTS, DIAGRAMS, AND MEDIA: ` + `Remove all images, screenshots, diagrams, and other visual media that represent user-specific content. ` + `Remove inline image/media nodes from the document body. ` + `Do not add explicit "[Insert image here]" placeholders at the exact location where the image was. ` + `Maintain the surrounding block structure (paragraphs, panels, layouts, headings, tables). ` + `If a section, panel body, or layout column contained only images or diagrams and no other text, ` + `clear the inner content but keep the surrounding container intact (panel, layout column, etc.). ` + `Do NOT add a separate placeholder inside the container \u{2014} the section already has its single placeholder. ` + // 8. Tables
`TABLES: ` + `Preserve all tables structurally: keep the same number of rows, columns, headers, and any table-level formatting. ` + `Remove user-specific content from table cells: clear the text content of all data cells. ` + `Remove inline statuses, dates, mentions, and smart links from within cells. ` + `Remove images or diagrams contained in table cells. ` + `Remove all text formatting artifacts from cleared cells, including: unordered list markers (bullets), ` + `ordered list numbers, checkboxes, bold/italic/strikethrough formatting, and any other inline formatting. ` + `Cleared cells should be completely empty \u{2014} no residual markers, hardBreak nodes, empty paragraph nodes, or whitespace. ` + `Do NOT add per-cell placeholders; rely on the section-level placeholder for guidance. ` + `If the table contains 3rd-party or unknown macro content inside cells and you are not sure what is safe to remove, ` + `preserve the macro container but clear only obvious user-visible text, statuses, dates, mentions, smart links, and images from those cells. ` + // 9. Code blocks
`CODE BLOCKS: ` + `Preserve every code block's position, language setting, and formatting. ` + `Remove the original code content. ` + `Replace it with a single comment-style placeholder that explains what kind of code belongs there. ` + `Example: // Add example usage of this API endpoint here. ` + `Do not add additional code lines beyond this single placeholder comment. ` + // 10. Decision lists and action items
`DECISION LISTS AND ACTION ITEMS: ` + `Preserve all decision list and action item structures, including their positions and any non-content metadata. ` + `Explicitly empty the textual content of each decision or action item: ` + `remove any user-specific description text, and remove inline statuses, dates, mentions, and smart links contained in item descriptions. ` + `Replace each item's description with a brief, bracketed placeholder that explains the kind of content to provide. ` + `Example for a decision: [Describe the decision made, the rationale, and any trade-offs considered.] ` + `Example for an action item: [Describe the task, owner, and expected completion criteria.] ` + `Do not remove the items themselves or their list structure. ` + // 11. 3rd-party or unknown macros
`3RD-PARTY OR UNKNOWN MACROS: ` + `Preserve all 3rd-party or unknown macros as structural containers. ` + `Where these macros clearly expose user-visible text, statuses, dates, mentions, smart links, or images ` + `in a way similar to normal content, you may clear that content following the same rules as above. ` + `If you are unsure whether text or elements inside a 3rd-party macro are configuration or content, ` + `err on the side of safety and leave them unchanged. ` + // 12. General safety rule
`GENERAL SAFETY RULE: ` + `Make the minimum structural changes necessary to clear user-specific content and introduce helpful, section-level placeholders. ` + `Never change the overall layout, headings, or macro structure of the page. ` + `When anything is ambiguous or seems risky to change (especially inside unknown macros), ` + `prefer to leave the structural element intact and only remove obviously user-specific content. ` + // Control instructions
`Do not open up the Rovo chat window. openChat=false.`;
const $9bd064651c03f40a$var$initialState = {
    isLoading: false,
    error: null,
    isSuccess: false
};
const $9bd064651c03f40a$export$c6bd49896df12d8c = ({ contentId: contentId, enabled: enabled = true } = {})=>{
    const [state, setState] = (0, $42omo.useState)($9bd064651c03f40a$var$initialState);
    const isActiveRef = (0, $42omo.useRef)(false);
    const contentIdRef = (0, $42omo.useRef)(contentId);
    // Keep contentIdRef in sync
    (0, $42omo.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    const reset = (0, $42omo.useCallback)(()=>{
        setState($9bd064651c03f40a$var$initialState);
        isActiveRef.current = false;
    }, []);
    // Use the same client ID as the editor so we receive the stream lifecycle events.
    // The conversation-assistant sends RovoStreamCompletedCommand targeted at
    // getConfluenceEditorClientId(contentId), so we must listen on the same ID.
    const editorClientId = (0, $6VfGD.getConfluenceEditorClientId)(contentId || 'fallback');
    // Set up bridge API with handlers for streaming lifecycle events
    const { send: send, ready: ready } = (0, $9XexZ.useRovoContentBridgeAPI)(editorClientId, (on)=>{
        // Handle stream completed - edit was successfully applied
        on((0, $6VfGD.RovoStreamCompletedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: true
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream error - edit failed
        on((0, $6VfGD.RovoStreamErroredCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: 'Failed to apply edit',
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream aborted - user cancelled
        on((0, $6VfGD.RovoStreamAbortedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
    });
    // Mark the client as ready to receive messages just-in-time
    const hasCalledReadyRef = (0, $42omo.useRef)(false);
    const keepPageStructure = (0, $42omo.useCallback)(()=>{
        if (enabled && !hasCalledReadyRef.current) {
            ready();
            hasCalledReadyRef.current = true;
        }
        // Validate required context
        if (!contentId) {
            setState({
                isLoading: false,
                error: 'Missing page context. Unable to keep page structure.',
                isSuccess: false
            });
            return;
        }
        // Set loading state
        setState({
            isLoading: true,
            error: null,
            isSuccess: false
        });
        // Track this request
        isActiveRef.current = true;
        try {
            send((0, $6VfGD.InlineInputBoxSendMessageCommand), {
                receiverId: (0, $6VfGD.ROVO_CHAT_CLIENT_ID),
                prompt: $9bd064651c03f40a$var$KEEP_PAGE_STRUCTURE_PROMPT,
                source: 'CONFLUENCE_KEEP_PAGE_STRUCTURE',
                productKey: 'confluence',
                deepResearchEnabled: false,
                webSearchEnabled: false,
                contentId: contentId,
                openChat: false,
                addCurrentPageAsContextUserPreference: true
            });
        } catch (error) {
            setState({
                isLoading: false,
                error: error instanceof Error ? error.message : 'Failed to send message to Rovo',
                isSuccess: false
            });
            isActiveRef.current = false;
        }
    }, [
        send,
        contentId,
        enabled,
        ready
    ]);
    return {
        ...state,
        keepPageStructure: keepPageStructure,
        reset: reset
    };
};


const $59c8ed409f168be8$var$i18n = (0, $h82at.defineMessages)({
    keepPageStructure: {
        id: "experiment-copy-with-rovo.button.label",
        defaultMessage: "Remove content, keep structure"
    },
    loading: {
        id: "experiment-copy-with-rovo.button.loading",
        defaultMessage: "Improving content..."
    },
    error: {
        id: "experiment-copy-with-rovo.button.error",
        defaultMessage: "Retry"
    },
    success: {
        id: "experiment-copy-with-rovo.button.success",
        defaultMessage: "Content improved"
    },
    rovoLoadingAlt: {
        id: "experiment-copy-with-rovo.rovo-loading.alt",
        defaultMessage: "Rovo is processing"
    }
});
const $59c8ed409f168be8$var$buttonContainerStyle = null;
const $59c8ed409f168be8$var$loadingIconStyle = null;
const $59c8ed409f168be8$var$KeepPageStructureIcon = ({ isLoading: isLoading, isSuccess: isSuccess, error: error, loadingAlt: loadingAlt })=>{
    if (isLoading) return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $jO3S6.LazyAnimatedRovoIcon), {
        alt: loadingAlt,
        width: "16px",
        height: "16px"
    }));
    if (error) return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (isSuccess) return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3AUgb))), {
        label: ""
    });
};
const $59c8ed409f168be8$export$3fdefd48e9dc313a = ({ contentId: contentIdProp })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = pageContentId || contentIdProp;
    const { keepPageStructure: keepPageStructure, isLoading: isLoading, error: error, isSuccess: isSuccess, reset: reset } = (0, $9bd064651c03f40a$export$c6bd49896df12d8c)({
        contentId: contentId,
        enabled: isRovoEnabled && (0, $9wGTI.fg)('aifc_create_enabled')
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('aifc_create_enabled')) return;
        if (isLoading) {
            reset();
            return;
        }
        if (isSuccess) {
            // Already applied; reset to allow re-running
            reset();
            return;
        }
        keepPageStructure();
    }, [
        isLoading,
        isSuccess,
        reset,
        keepPageStructure
    ]);
    const loadingAlt = formatMessage($59c8ed409f168be8$var$i18n.rovoLoadingAlt);
    const renderIcon = (0, $42omo.useCallback)(()=>/*#__PURE__*/ $42omo.createElement($59c8ed409f168be8$var$KeepPageStructureIcon, {
            isLoading: isLoading,
            isSuccess: isSuccess,
            error: error,
            loadingAlt: loadingAlt
        }), [
        isLoading,
        isSuccess,
        error,
        loadingAlt
    ]);
    const isAllowedPageMode = pageMode === (0, $cD1qu.PageMode).LIVE || pageMode === (0, $cD1qu.PageMode).EDIT;
    if (!isAllowedPageMode || !isRovoEnabled || !(0, $9wGTI.fg)('aifc_create_enabled')) return null;
    const getButtonLabel = ()=>{
        if (error) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "span",
            color: "color.text.danger"
        }, formatMessage($59c8ed409f168be8$var$i18n.error));
        if (isLoading) return formatMessage($59c8ed409f168be8$var$i18n.loading);
        if (isSuccess) return formatMessage($59c8ed409f168be8$var$i18n.success);
        return formatMessage($59c8ed409f168be8$var$i18n.keepPageStructure);
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "aria-live": "polite",
        className: (0, $gMc0m.default)([
            "_ca0qu2gc _n3td1b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: renderIcon,
        onClick: handleClick,
        testId: "experiment-copy-with-rovo-button"
    }, getButtonLabel()));
};


const $52d3d74efbba00ee$var$i18n = (0, $h82at.defineMessages)({
    titlePage: {
        id: "experiment-copy-with-rovo.whats-next-card.title-page",
        defaultMessage: "Make this copied page your own"
    },
    titleLiveDoc: {
        id: "experiment-copy-with-rovo.whats-next-card.title-live-doc",
        defaultMessage: "Make this copied live doc your own"
    },
    description: {
        id: "experiment-copy-with-rovo.whats-next-card.description",
        defaultMessage: "Ask Rovo to remove text and images, but keep important structures like headers or tables."
    },
    closeLabel: {
        id: "experiment-copy-with-rovo.whats-next-card.close",
        defaultMessage: "Dismiss"
    }
});
const $52d3d74efbba00ee$var$styles = {
    wrapper: "_1e0c1txw _1bah1h6o _1bsb1osq _1q51pxbi _85i5pxbi",
    cardContainer: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjcpxbi _18zrpxbi _p12fukw8 _1bsb1osq _vchhusvi _bfhkvuon",
    title: "_16jlkb7n"
};
const $52d3d74efbba00ee$export$8ba7c10a65fdddc3 = ({ contentId: contentId })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setIsDismissed(true);
    }, []);
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "whats-next-card-wrapper",
        className: (0, $gMc0m.default)([
            $52d3d74efbba00ee$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "whats-next-card",
        className: (0, $gMc0m.default)([
            $52d3d74efbba00ee$var$styles.cardContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $52d3d74efbba00ee$var$styles.title
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "span",
        weight: "bold",
        size: "large"
    }, formatMessage(isLivePage ? $52d3d74efbba00ee$var$i18n.titleLiveDoc : $52d3d74efbba00ee$var$i18n.titlePage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($52d3d74efbba00ee$var$i18n.closeLabel),
        onClick: handleDismiss,
        testId: "whats-next-card-close"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($52d3d74efbba00ee$var$i18n.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $59c8ed409f168be8$export$3fdefd48e9dc313a), {
        contentId: contentId
    })))));
};


const $36919fc669e0d2b2$export$deb6b26d156013d1 = ({ contentId: contentId })=>{
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const [showBanner, setShowBanner] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $81LQM.isRecentlyCopiedContentId)(contentId)) return;
        if ((0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'banner')) setShowBanner(true);
        else if ((0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat')) toggleConversationAssistantUIMode({
            targetMode: (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
        (0, $81LQM.clearRecentlyCopiedContentId)(contentId);
    }, [
        contentId,
        sidebarApi,
        toggleConversationAssistantUIMode
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52d3d74efbba00ee$export$8ba7c10a65fdddc3), {
        contentId: contentId
    });
};
module.exports["CopyWithRovo"] = $36919fc669e0d2b2$export$deb6b26d156013d1;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt }, { reset: reset, clearInitialPrompt: clearInitialPrompt, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("81LQM", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

/**
 * Builds the localStorage key for a given content ID by appending the
 * content ID to the registered storage key.
 */ const $89f054c4d30d73d3$var$buildKey = (contentId)=>{
    return `${(0, $1UApO.keys).PAGE_CREATED_FROM_COPY}.${contentId}`;
};
const $89f054c4d30d73d3$export$1ae3f5a2a74118cf = (contentId)=>{
    const key = $89f054c4d30d73d3$var$buildKey(contentId);
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, 'true');
};
const $89f054c4d30d73d3$export$3ac9f2782c051194 = (contentId)=>{
    const key = $89f054c4d30d73d3$var$buildKey(contentId);
    return (0, $17wUi.confluenceLocalStorageInstance).getItem(key) === 'true';
};
const $89f054c4d30d73d3$export$97791fe4257e1c4b = (contentId)=>{
    const key = $89f054c4d30d73d3$var$buildKey(contentId);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
module.exports["setRecentlyCopiedContentId"] = $89f054c4d30d73d3$export$1ae3f5a2a74118cf;
module.exports["isRecentlyCopiedContentId"] = $89f054c4d30d73d3$export$3ac9f2782c051194;
module.exports["clearRecentlyCopiedContentId"] = $89f054c4d30d73d3$export$97791fe4257e1c4b;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("9XexZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");

const $26e790de36bba91a$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $15h8H.getBrowserBridgeAPI)())=>{
    const refApi = (0, $42omo.useRef)(apiInstance);
    const refReady = (0, $42omo.useRef)(false);
    const refMount = (0, $42omo.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $42omo.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $42omo.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $42omo.useCallback)((command, params)=>{
        // devx: provide current `clientId`
        return api.send(command, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $42omo.useCallback)((command, params, options)=>{
        api.broadcast(command, params, options);
    }, [
        api
    ]);
    const teardown = (0, $42omo.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
	 * If we have already mounted our handlers once and marked ourselves as ready, then this
	 * bridge API client is already capable of receiving & handling commands. On subsequent renders
	 * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
	 *
	 * This will ensure the newest state of every handler is being used, with no stale references
	 * in closures, as can often occur with initialise-only-once code in React.
	 */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $26e790de36bba91a$export$a74fbbd6fb01001c;

});

parcelRegister("3AUgb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f778c83bc8082fc596ba12347f14cf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29e05ff453171dc1$var$_react = $29e05ff453171dc1$var$_interopRequireDefault((parcelRequire("42omo")));

var $29e05ff453171dc1$var$_baseNew = $29e05ff453171dc1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $29e05ff453171dc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for remove filler words functionality in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29e05ff453171dc1$var$AiGenerativeRemoveIcon = (props)=>/*#__PURE__*/ $29e05ff453171dc1$var$_react.default.createElement($29e05ff453171dc1$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 0a.75.75 0 0 1 .706.494l.535 1.468a.5.5 0 0 0 .298.298l1.468.535a.75.75 0 0 1 0 1.41l-1.468.535a.5.5 0 0 0-.298.299l-.535 1.467a.75.75 0 0 1-1.41 0L11.26 5.04a.5.5 0 0 0-.298-.299l-1.467-.535a.75.75 0 0 1 0-1.41l1.467-.535a.5.5 0 0 0 .298-.298l.536-1.468A.75.75 0 0 1 12.5.001M5.4 6.194a2 2 0 0 1 2.791-.034l2.131 2.025a2 2 0 0 1 .04 2.86L7.2 14.226l-.014.014-1.263 1.206A2 2 0 0 1 4.541 16h-.91a2 2 0 0 1-1.305-.484l-.124-.107-.042-.038-1.556-1.557a2 2 0 0 1 0-2.828L2.279 9.31zm1.758 1.053a.5.5 0 0 0-.698.009L3.87 9.84l2.795 2.794L9.3 9.986a.5.5 0 0 0-.01-.715zm-1.564 6.44L2.81 10.9l-1.146 1.145a.5.5 0 0 0 0 .708l1.537 1.536.103.09a.5.5 0 0 0 .326.12h.91a.5.5 0 0 0 .346-.139zM16 16H9v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$29e05ff453171dc1$var$AiGenerativeRemoveIcon.displayName = 'AiGenerativeRemoveIcon';
var $29e05ff453171dc1$var$_default = module.exports.default = $29e05ff453171dc1$var$AiGenerativeRemoveIcon;

});


//# sourceMappingURL=CopyWithRovo.02c07df5.js.map
